// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__WX0P3","empty":"ModalGraph_empty__1Togv"};